import './ColorPalette.5bf1e6bdfd951237ae055c4f295746eb.css';
export default {"colorPicker":"_colorPicker_7yb3z_1","section":"_section_7yb3z_1"};